import React, { useState, useEffect } from 'react';
import { Modal, Spin, message, Input } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import CompanyLogo from '../../public/img/company/companyLogo.png';
import $ from 'jquery';

import './companyInfoModal.css'

const { TextArea } = Input
const CompanyInfoModal = (props) => {
    const [isLoad, setIsLoad] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [partnerModel, setPartnerModel] = useState(true);

    useEffect(() => {
        searchById(Config?.partnerInfo?.partnerId)
    }, []);

    const searchById = (partnerId) => {
        Base.callBackApi("partnerDetail/searchById", {'partnerId': partnerId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setPartnerModel(model)
                let companyProfile = model?.companyProfile?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#companyProfile").empty().append(companyProfile);
            } else {
                message.error(data.msg)
            }
        })
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={true}//是否显示右上角的关闭按钮
            onCancel={() => props.onClose()}
            maskClosable={false}//点击蒙层是否允许关闭	
            width='1064px'//弹框宽度
            footer={false}
            style={{ minWidth: '450px' }} // 设置最小宽度为300px
        >
            <div className='companyInfoModal'>
                <Spin size="large" spinning={isLoad} >
                    <div className="websiteSysCol flexBox">
                        <div className='companyLogoBox'>
                            {partnerModel?.companyLogo ? <img src={Config.partnerImg + partnerModel?.companyLogo + '?' + Config.sasToken} /> : <img src={CompanyLogo} />}
                            <div className='companyNameBox'>{partnerModel?.companyName}</div>
                        </div>
                    </div>
                    <div className='websiteSysRow'>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company Website</div>
                            <div className="websiteSysInput">
                                {partnerModel.companyWebsite}
                            </div>
                        </div>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company LinkedIn</div>
                            <div className="websiteSysInput">
                                {partnerModel.companySocailMedia}
                            </div>
                        </div>
                    </div>
                    <div className='websiteSysRow'>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company YouTube</div>
                            <div className="websiteSysInput">
                                {partnerModel.companyYouTuBe}
                            </div>
                        </div>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company Instagram</div>
                            <div className="websiteSysInput">
                                {partnerModel.companyInstagram}
                            </div>
                        </div>
                    </div>
                    <div className='websiteSysRow'>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company Facebook</div>
                            <div className="websiteSysInput">
                                {partnerModel.companyFacebook}
                            </div>
                        </div>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Company WeChat</div>
                            <div className="websiteSysInput">
                                {partnerModel.companyWeChat}
                            </div>
                        </div>
                    </div>
                    <div className='websiteSysRow'>
                        <div className='websiteSysCol'>
                            <div className="websiteSysParam">Other</div>
                            <div className="websiteSysInput">
                                {partnerModel.other}
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysRow">
                        <div className="websiteSysCol">
                            <div className="websiteSysParam ">Office Address</div>
                            <div className="websiteSysInputMax">
                                <TextArea maxLength={1000} rows={3} aria-disabled value={partnerModel.companyLocation} />
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysRow">
                        <div className="websiteSysCol">
                            <div className="websiteSysParam ">Company Description</div>
                            <div className="websiteSysInputMax">
                                <div className='editorBox' id='companyProfile'>

                                </div>
                            </div>
                        </div>
                    </div>
                </Spin>
            </div>
        </Modal>
    )
}

CompanyInfoModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}
export default CompanyInfoModal;